module.exports = __webpack_public_path__ + "img/1.f95c3a7b.png";